import { Component, OnInit, Input } from '@angular/core';
import { Router, NavigationExtras } from '@angular/router';
import { SiteConfigurationService } from '../../common/site-configuration.service'; 
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import * as myGlobals from '../../global';

@Component({
  selector: 'tnrandomadv',
  template: '',
  templateUrl: '../../themes/default/html/randomadv.component.html',
})
export class Tnrandomadv implements OnInit {
    
    _mySettings: any;
    RandomItem: any [] = null;
    indice: number = -1;
    Bigadvlist: any = [];

    @Input()
    set advlist(_data:any){
        if (_data != null){
            this.Bigadvlist = _data;
            this.getRandomItem();
        }
    }

    @Input()
    set idx(value:number){
        if (value > -1){
            this.indice = value;
            this.getRandomItem();
        }
    }

    constructor(private mySettings: SiteConfigurationService,private router: Router,private sanitizer: DomSanitizer) {
        this._mySettings = mySettings.getFullConfig();
    }

    ngOnInit() {
    
    }

    removeHTML(string){
        string = string.replace(/<[^>]+>/g, '');
        return string;
    }
    upFirst(value){
        return value.charAt(0).toUpperCase() + value.slice(1);
    }
    sanitizeimg(img: any = []){
        if (img == undefined){
        return this._mySettings.e400.images.noAdsImagePlaceHolder;
        }
        img = JSON.parse(img);
        img = myGlobals.apiBasePath + img[0].url
        img = this.sanitizer.bypassSecurityTrustUrl(img);
        return img;
    }

    getRandomItem() {
        if(this.Bigadvlist == null || this.Bigadvlist.length == 0 || this.indice == -1 ){
            return;
        }
        let randomIndex = this.indice; //Math.floor(Math.random() * Bigadvlist.length); 
        let randomItem = this.Bigadvlist[randomIndex];
        this.RandomItem=randomItem;
      }

}


// WEBPACK FOOTER //
// A:/Work/Siti/Volpe2/src/app/components/tnrandomadv/randomadv.component.ts